<template>
  <footer class="app-footer">
    <div class="footer-content">
      <span>Copyright &copy; NEDAM FACTURA - v1.25.001</span>
    </div>
  </footer>
</template>

<style scoped>
.app-footer {
  width: 100%;
  padding: 18px 24px;
  text-align: center;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
}

.app-footer .footer-content {
  margin: 0 auto;
  max-width: 1280px;
}

@media (max-width: 575px) {
  .app-footer {
    font-size: 11px;
    padding: 14px 16px;
  }
}
</style>
